import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const LateEvening = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.234 11.82a.416.416 0 0 1 .586.472 6.87 6.87 0 0 1-1.796 3.156 6.788 6.788 0 0 1-9.598.126 6.792 6.792 0 0 1 .126-9.602 6.862 6.862 0 0 1 3.139-1.791.424.424 0 0 1 .48.597 5.359 5.359 0 0 0 .992 6.057 5.354 5.354 0 0 0 6.07.985zM14.45 2.826a.627.627 0 0 1 1.1 0l.486.89a.625.625 0 0 0 .249.248l.889.486a.627.627 0 0 1 0 1.1l-.89.486a.625.625 0 0 0-.247.249l-.486.889a.627.627 0 0 1-1.101 0l-.486-.89a.625.625 0 0 0-.249-.248l-.889-.486a.627.627 0 0 1 0-1.1l.89-.486a.625.625 0 0 0 .248-.249l.486-.889z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

LateEvening.propTypes = {
  color: PropTypes.string
};

LateEvening.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default LateEvening;
